import _ from 'lodash'

import { FETCHED_MYD_EVALUATIONS } from '_reducers/myd_evaluations'

export const FETCHED_MYD_PLANNING = 'FETCHED_MYD_PLANNING'
export const FETCHED_MYD_PLANNINGS = 'FETCHED_MYD_PLANNINGS'
export const FETCHING_MYD_PLANNING = 'FETCHING_MYD_PLANNING'
export const FETCHING_MYD_PLANNINGS = 'FETCHING_MYD_PLANNINGS'
export const NEW_MYD_PLANNING = 'NEW_MYD_PLANNING'
export const SAVE_MYD_PLANNING = 'SAVE_MYD_PLANNING'


export function mydPlannings(mydPlannings=[], action) {
  switch (action.type) {
    case FETCHING_MYD_PLANNINGS:
      return {
        isFetching: true,
        data: (action.removeOldData ? [] : mydPlanning.data),
      }
    case FETCHED_MYD_PLANNINGS:
      return {
        isFetching: false,
        data: action.mydPlannings
      }
    case NEW_MYD_PLANNING:
      return {
        isFetching: false,
        data: [
          ...mydPlannings,
          action.mydPlanning
        ]
      }
    case SAVE_MYD_PLANNING:
      const mydPlanningIndex = _.findIndex(mydPlannings.data, {id: action.mydPlanning.id})
      return {
        isFetching: false,
        data: _.map(mydPlannings.data, (item, index) => {
          if (index === mydPlanningIndex)
            return action.mydPlanning
          return item
        })
      }
    default:
      return mydPlannings
  }
}

const mydPlanningInit = {
  isFetching: false,
  data: {},
}

export function mydPlanning(mydPlanning=mydPlanningInit, action) {
  switch (action.type) {
    case FETCHING_MYD_PLANNING:
      return {
        isFetching: true,
        data: action.removeOldData ? {} : mydPlanning,
      }
    case NEW_MYD_PLANNING:
    case SAVE_MYD_PLANNING:
    case FETCHED_MYD_PLANNING:
      return {
        isFetching: false,
        data: action.mydPlanning,
      }
    case FETCHED_MYD_EVALUATIONS:
      return {
        ...mydPlanning,
        data: {
          ...mydPlanning.data,
          mydEvaluations: action.mydEvaluations,
        },
      }
    default:
      return mydPlanning
  }
}
